<template>
  <fragment>
    <!-- 데이터 테이블 -->
    <PagingTable ref="table" :sourceList="tableItems">
      <template #header>
        <caption>
          <span class="blind">대상자별 반복소식 건별</span>
        </caption>
        <colgroup>
          <col width="5%" />
          <col width="10%" />
          <!-- <col width="15%" /> -->
          <col />
          <col width="10%" />
          <col width="8%" />
          <col width="7%" />
          <col width="10%" />
          <col width="12%" />
        </colgroup>
        <thead class="table_list_head">
          <tr>
            <th data-sort="id">번호</th>
            <th class="center">소식종류</th>
            <!-- <th class="center" data-sort="rcpDesc">받는사람</th> -->
            <th class="center">소식 내용</th>
            <th class="center" data-sort="userName">작성자</th>
            <th class="sorting">스피커알림</th>
            <th class="sorting">전송종류</th>
            <th class="sorting" data-sort="sendDate">전송 시간</th>
            <th class="sorting" data-sort="readDate">확인 시간</th>
          </tr>
        </thead>
      </template>

      <template #row="{ rowData }">
        <tr>
          <td>{{rowData.id}}</td>
          <RepeatTypeTextColumn
            :newsType="rowData.newsType"
            :customNewsType="rowData.customNewsType"
            :short="true"
          />
          <!-- <td>{{rowData.rcpDesc}}</td> -->
          <EditedTextColumn
            :value="rowData.boardContent"
            :rowData="rowData"
            :maxLength="60"
            @click="openRepeatDetail({ newsId: rowData.id })"
          />
          <td>{{rowData.userName}}</td>
          <PushSuccessColumn :value="rowData.pushSuccess" />
          <td>{{getRepeatSendTypeText(rowData.sendType)}}</td>
          <td>{{$utils.timeText(rowData.sendDate)}}</td>
          <ReadDateColumn :value="rowData.readDate" :newsType="rowData.newsType" />
        </tr>
      </template>
    </PagingTable>

    <!-- 버튼 영역 -->
    <div class="section_button">
      <ExcelDownloadButton v-if="res" :filename="$utils.excelName('반복맞춤소식', '건별', res.rcpName)">
        <ExcelTable :sourceList="tableItems" />
      </ExcelDownloadButton>
      <HelpButton contentId="HELP_01" />
    </div>
  </fragment>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import ExcelTable from "./excelTables/Recipient.repeat.itemBy";

export default {
  mixins: [newsMixin],
  components: {
    ExcelTable
  },
  props: {
    rcpId: String,
    registerType: String
  },
  data() {
    return {
      res: null
    };
  },
  computed: {
    tableItems() {
      if (!this.res) return null;
      return this.res.boardList;
    }
  },
  methods: {
    requestOptions() {
      return { params: { searchNewsType: this.registerType } };
    },
    loadData(keepTableState) {
      const options = this.requestOptions();
      this.$axios
        .get(`/admin/v2/news/repeat/rcp/${this.rcpId}/logs/itemBy`, options)
        .then(({ data }) => {
          this.res = data.data;
          this.$emit("dataLoaded", this.res);
          if (!keepTableState && this.$refs.table)
            this.$refs.table.resetState();
        });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
